import React from 'react';
import EmploiDuTempsPrint from 'containers/EmploiDuTemps/Print/Loadable';
import CahierJournalPrint from 'containers/CahierJournal/Print/Loadable';
import ProgrammationV2Print from 'containers/Programmations/ProgV2/Print/Loadable';
import ElevesViewPrint from 'containers/Eleves/Print/ElevesViewPrint/Loadable';
import ElevePresences from 'containers/Eleves/Print/Presences/Loadable';
import LivretElevePrint from 'containers/Livrets/LivretEval/LivretEleve/Print/Loadable';
import CarnetPrint from 'containers/CarnetsDeNotes/CarnetDetails/Print/Loadable';
import CarnetElevePrint from 'containers/CarnetsDeNotes/CarnetEleve/Print/Loadable';
import PlannerCalendarPrint from 'containers/Planner/Main/Calendar/Print/Loadable';
import PlannerCategoriesPrint from 'containers/Planner/Main/Categories/Print/Loadable';
import PyramideDesAgesPrintData from 'containers/PyramidesDesAges/Print/Loadable';
import TrombinoscopePrintData from 'containers/Trombinoscope/Print/Loadable';
import RegistreAppelPrintData from 'containers/RegistreAppel/Print/Loadable';
import RegistreAppelDetailsPrintData from 'containers/RegistreAppel/Print/Registre/Loadable';
import AutoPrintFicheDePrep from 'containers/Sequences/LoadableAutoPrintFicheDePrep';
import InvoiceComponent from 'containers/Invoices/Loadable';
import FicheDePrepPrint from 'containers/Sequences/Print/FicheDePrep/Loadable';
import SequencePrint from 'containers/Sequences/Print/Loadable';
import BudgetPrint from 'containers/Budgets/Print/Loadable';
import StructureEcole from 'containers/StructureEcole/Loadable';
import AutoPrintStructure from 'containers/StructureEcole/AutoPrint/Loadable';
import Etiquettes from 'containers/Etiquettes/Loadable';
import AutoPrintEtiquettes from 'containers/Etiquettes/AutoPrint/Loadable';
import HtmlDocumentPrint from 'containers/Editor/Print/Loadable';

export const PrintRoutes = {
  path: 'print',
  children: [
    {
      path: 'annee-scolaire/:schoolyearId/ecole/:schoolId',
      children: [
        {
          path: 'emploi-du-temps/:edtId',
          element: <EmploiDuTempsPrint />,
        },
        {
          path: 'cahier-journal/:view/:year/:month/:day',
          element: <CahierJournalPrint />,
        },
        {
          path: 'programmations/:programmationId',
          element: <ProgrammationV2Print />,
        },
        {
          path: 'programmations/:programmationId/v2',
          element: <ProgrammationV2Print />,
        },
        {
          path: 'eleves/:eleveId/presences',
          element: <ElevePresences />,
        },
        {
          path: 'eleves-views/:viewId',
          element: <ElevesViewPrint />,
        },
        {
          path: 'livrets/:livretEvalId/livrets-eleves/:livretEleveId',
          element: <LivretElevePrint />,
        },
        {
          path: 'carnets-de-notes/:carnetDeNotesId',
          element: <CarnetPrint />,
        },
        {
          path: 'carnets-de-notes/:carnetDeNotesId/eleves/:eleveId',
          element: <CarnetElevePrint />,
        },
        {
          path: 'planners/:plannerId/calendar',
          element: <PlannerCalendarPrint />,
        },
        {
          path: 'planners/:plannerId/categories',
          element: <PlannerCategoriesPrint />,
        },
        {
          path: 'pyramide-des-ages/:pyramideId',
          element: <PyramideDesAgesPrintData />,
        },
        {
          path: 'trombinoscopes/:trombinoscopeId',
          element: <TrombinoscopePrintData />,
        },
        {
          path: 'appels/stats',
          element: <RegistreAppelPrintData />,
        },
        {
          path: 'appels/registre',
          element: <RegistreAppelDetailsPrintData />,
        },
        {
          path: 'budgets/:budgetId',
          element: <BudgetPrint />,
        },
      ],
    },
    {
      path: 'users/:userId/sequences/:sequenceId/fiches-de-prep/:ficheDePrepId/print',
      element: <AutoPrintFicheDePrep />,
    },
    {
      path: 'invoices/:userId/:paymentId',
      element: <InvoiceComponent />,
    },
    {
      path: 'users/:userId/sequences/:sequenceId/fiches-de-prep/:ficheDePrepId',
      element: <FicheDePrepPrint />,
    },
    {
      path: 'users/:userId/fiches-de-prep/:ficheDePrepId',
      element: <FicheDePrepPrint />,
    },
    {
      path: 'users/:userId/sequences/:sequenceId',
      element: <SequencePrint />,
    },
    {
      path: 'structure-ecole',
      element: <StructureEcole />,
    },
    {
      path: 'structure-ecole/pdf',
      element: <AutoPrintStructure />,
    },
    {
      path: 'etiquettes',
      element: <Etiquettes />,
    },
    {
      path: 'etiquettes/pdf',
      element: <AutoPrintEtiquettes />,
    },
    {
      path: 'html-document/:documentId',
      element: <HtmlDocumentPrint />,
    },
  ],
};
